import {CanvasPoint} from '@shared/models/structure';
import {TileId} from '@shared/models/tile';
import {Option} from '@shared/models/option';

export enum PointMenuOptionId {
  ADD_REMOVE = 'add-remove',
  DELETE = 'delete',
  MOVE_UP = 'move-up',
  MOVE_DOWN = 'move-down',
}

export function sameTileIds(a: TileId[], b: TileId[]): boolean {
  return a.length === b.length && a.every((id, i) => id === b[i]);
}

export function isSamePoint(a: CanvasPoint, b: CanvasPoint): boolean {
  return a === b || (a.X === b.X && a.Y === b.Y && sameTileIds(a.TileIDs, b.TileIDs));
}

export function swapTileIds(tileIds: TileId[], index: number, delta: -1 | 1): TileId[] | null {
  const target = index + delta;
  if (index < 0 || index >= tileIds.length || target < 0 || target >= tileIds.length) return null;

  const swapped = [...tileIds];
  [swapped[index], swapped[target]] = [swapped[target], swapped[index]];
  return swapped;
}

export function buildPointMenuOptions(point: CanvasPoint, tileIndex: number | null): Option[] {
  const options: Option[] = [
    {id: PointMenuOptionId.ADD_REMOVE, name: 'Add/Remove Tiles'},
    {id: PointMenuOptionId.DELETE, name: 'Delete'},
  ];
  if (tileIndex !== null && point.TileIDs.length > 1) {
    if (tileIndex > 0) options.push({id: PointMenuOptionId.MOVE_UP, name: 'Move Tile Up'});
    if (tileIndex < point.TileIDs.length - 1) options.push({id: PointMenuOptionId.MOVE_DOWN, name: 'Move Tile Down'});
  }
  return options;
}
